// @ts-ignore
import config from '../config/config'

export const getAutoOnboardingApiUrl = () => {
  return `${config.platformAPI}/auto-onboarding`
}

export const getAutoOnboardingV2Url = () => {
  return `${config.platformAPI}/auto-onboarding-service`
}



// WEBPACK FOOTER //
// ./src/utils/commonV2.ts